module.exports = __webpack_public_path__ + "static/img/documents--phab.dba867c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/documents--phab.jpg
// module id = dOhe
// module chunks = 2